import { BooleanFilterValueBase } from "abweb/dto/generated/inputargs/BooleanFilterValueBase";
export class BooleanFilterValue extends BooleanFilterValueBase {
  static createBooleanFilterValue(value) {
    const retVal = new BooleanFilterValue();
    retVal.initBooleanFilterValue(null, value);
    return retVal;
  }
  constructor() {
    super();
    this.initBooleanFilterValue(null, null);
  }
  clone() {
    return BooleanFilterValue.createBooleanFilterValue(this.value);
  }
  get value() {
    return super.value;
  }
  set value(value) {
    super.value = value;
  }
}
//# sourceMappingURL=BooleanFilterValue.js.map
